// extracted by mini-css-extract-plugin
export default {"container":"VersionMismatchModal-module__container--oOQF4","animatedBackground":"VersionMismatchModal-module__animatedBackground--NP8vD"};